var _defs, _circle, _ellipse, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergingMarketsSprout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Emerging markets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#aa0000"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    clipPath: "url(#c)",
    cx: 8,
    cy: 19.2,
    rx: 10,
    ry: 7.4,
    fill: "#dd9d01"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffee33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12.1V7.6h1.5v4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 8.4C5.2 8.6 3.6 7.3 3.4 4.9 5.9 4.6 7.6 6 7.6 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 7.4C8.3 4.6 10 2.9 12.8 2.9 12.9 5.7 11.2 7.4 8.4 7.4z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergingMarketsSprout);
export default __webpack_public_path__ + "static/media/emerging-markets-sprout.46746c559be1445d67cfaf1b6f1d6c22.svg";
export { ForwardRef as ReactComponent };